/** Runtime configuration (Vite env; all optional for same-origin defaults). */
export interface AppConfig {
  /** API origin ("" = same origin / dev proxy). Auth lives at {apiBase}/api/auth, tRPC at {apiBase}/trpc. */
  apiBase: string;
  /** Media CDN origin for SmartImage ("" = same origin). */
  mediaBase: string;
  /** VAPID public key for web push (absent → push opt-in surface hidden). */
  vapidPublicKey: string | undefined;
  /**
   * Non-production stages gate the GAME itself behind Amazon Federate
   * (Midway): beta and personal stacks are internal environments, so no
   * anonymous play. Production is public — that is the whole point of the
   * flag rather than a hardcoded stage check in the UI.
   */
  requireFederate: boolean;
}

const env = (import.meta.env ?? {}) as Record<string, string | undefined>;

export const appConfig: AppConfig = {
  apiBase: env.VITE_API_URL ?? "",
  mediaBase: env.VITE_MEDIA_URL ?? "",
  vapidPublicKey: env.VITE_VAPID_PUBLIC_KEY,
  requireFederate: env.VITE_REQUIRE_FEDERATE === "1",
};
